export default "https://cdn-static.gokick.com/assets/62cc856e78696df0fd8dcc0a94c6851d482ca838/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";